import {
  Component, ViewEncapsulation, Inject, Input, Renderer2, ElementRef, OnDestroy
} from "@angular/core";
import {DOCUMENT} from "@angular/platform-browser";

declare const window: any;

@Component({
  templateUrl: './disqus.component.html',
  selector: 'disqus',
  styleUrls: [ './disqus.component.scss' ],
  encapsulation: ViewEncapsulation.None
})

export class DisqusComponent implements OnDestroy {

  @Input('page-identifier') pageIdentifier: string;
  @Input('page-url') pageUrl: string;
  @Input('page-language') pageLanguage: string;
  @Input('shortname') shortname: string;

  constructor(@Inject('isBrowser') protected isBrowser: boolean,
              @Inject(DOCUMENT) protected document: any,
              protected renderer: Renderer2,
              protected el: ElementRef) { }

  public init() {
    if(this.isBrowser) {
      if (typeof window.DISQUS == 'undefined') {
        this.addScriptTag()
      } else {
        this.reset();
      }
    }
  }

  protected reset() {

    if (this.isBrowser && typeof window.DISQUS != 'undefined') {

      let _self = this;

      window.DISQUS.reset({
        reload: true,
        config: function () {
          this.page.identifier = _self.pageIdentifier;
          this.page.url = _self.pageUrl;
          this.language = _self.pageLanguage;
        }
      });

    }
  }

  public hideComments() {
    if(this.isBrowser){
      if($('.comments-wrap').hasClass('comments-wrap-show')) {
        $('.comments-wrap').addClass('comments-wrap-hide');
        $('.comments-wrap').removeClass('comments-wrap-show');

        $('.comments-background').addClass('comments-background-hide');
        $('.comments-background').removeClass('comments-background-show');
        $('body').css('overflow','auto');
      }
    }
  }

  public showComments() {
    if(this.isBrowser) {
      this.init();
      $('.comments-wrap').addClass('comments-wrap-show');
      $('.comments-wrap').removeClass('comments-wrap-hide');

      $('.comments-background').addClass('comments-background-show');
      $('.comments-background').removeClass('comments-background-hide');
      $('body').css('overflow', 'hidden');
    }
  }

  public determineVisibility() {
    if(this.isBrowser){
      if($('.comments-wrap').hasClass('comments-wrap-show')) {
        this.hideComments();
      } else {
        this.showComments();
      }
    }
  }

  private addScriptTag() {
    window.disqus_config = this.getConfig();
    const disqusScript = this.renderer.createElement('script');
    disqusScript.src = `//${this.shortname}.disqus.com/embed.js`;
    disqusScript.async = true;
    disqusScript.type = 'text/javascript';
    this.renderer.setAttribute(disqusScript, 'data-timestamp', new Date().getTime().toString());
    this.renderer.appendChild(this.el.nativeElement, disqusScript);
  }

  public getConfig(): () => void {
    let _self = this;
    return function () {
      this.page.url = _self.pageUrl;
      this.page.identifier = _self.pageIdentifier;
      this.language = (!!_self.pageLanguage) ? _self.pageLanguage : 'en';
    };
  }

  ngOnDestroy() {
    if(this.isBrowser) {
      window.DISQUS = undefined;
      window.disqus_config = undefined;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/comments/disqus.component.ts